import React from "react";
import IreUpdate from "./IreInsertion/IreUpdate";
import IreInsertion from "./IreInsertion/IreInsertion";
const IREMaster = () => {
  return (
    <div className="container" style={{ minHeight: "90vh" }}>
      <IreInsertion />
      <hr />
      <IreUpdate />
    </div>
  );
};
export default IREMaster;
